import { useAuth0 } from "@auth0/auth0-react";
import { Outlet } from "react-router";

export default function ProtectedRoute() {
    const { isAuthenticated, loginWithRedirect } = useAuth0();

    // if the user is not authenticated, redirect to login page
    if (!isAuthenticated) loginWithRedirect();
    else return <Outlet />
}